import { Component } from '@angular/core';
import {Router} from '@angular/router';

import {routerTransition} from '../router.animations';
import { UserSettingsService } from '../shared/user-settings.service';

@Component({
    selector: 'dashboard-component',
    animations: [ routerTransition ],
    templateUrl: 'dashboard.component.html'
})
export class DashboardComponent {
    resizer;
    sizeClass = '';
    constructor(private userSettings: UserSettingsService, router: Router) {
        this.updateClass(window);
    }
    getState(outlet) {
        return outlet.activatedRouteData.state;
    }
    resize(e) {
        let resizer = this.resizer;
        if( resizer ) {
            return;
        }
        resizer = setTimeout(() => {
            resizer = null;
            this.updateClass(e.target);
        }, 150);
    }
    updateClass(elem) {
        let width = elem.innerWidth;
        if( width < 768 ) {
            this.sizeClass = 'mobile';
        }
        if( width >= 768 && width < 1030 ) {
            this.sizeClass = 'tablet';
        }
        if( width >= 1030 ) {
            this.sizeClass = 'desktop';
        }
    }
}



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/dashboard/dashboard.component.ts